var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoicePostPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .5;\n      }\n\n      .cls-2 {\n        fill: #a3a3a2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.6,92.3c0,9.1-7.4,16.6-16.6,16.6s-15.4-6.2-16.4-14.5l1.8-.2c.9,7.4,7.2,12.9,14.7,12.9s15-6.6,14.8-14.8c-.5-17.5-23-18.4-27.9-6.8h7.2v1.8h-10.7v-10.6h1.8v8.1c2.8-5.5,8.5-9.1,14.8-9.1,9.1,0,16.6,7.4,16.6,16.6h-.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "89.1 99.8 82.1 92.7 82.1 82.5 83.9 82.5 83.9 91.9 90.5 98.5 89.1 99.8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-3",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.6,36l-8.5-8.8c-.2-.2-.4-.3-.6-.3h-37.6c-.5,0-.9.4-.9.9v64.4c0,.5.4.9.9.9h20.3v-1.8h-19.4V28.8h36.3l8,8.2v29.4h1.8v-29.8c0-.2,0-.5-.3-.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.5,33.5v4h1v-4h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.5,33.5v2.3h0l-1.6-2.3h-.8v4h1v-2.3h0l1.6,2.3h.8v-4h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.8,33.5l-.9,2.9h0l-.9-2.9h-1.1l1.3,4h1.3l1.3-4h-1.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.5,34.3c-.2-.3-.4-.5-.7-.7s-.6-.2-1-.2-.7,0-1,.2c-.3,0-.5.4-.7.7s-.2.7-.2,1.1,0,.8.2,1.1.4.5.7.7.6.2,1,.2.7,0,1-.2.5-.4.7-.7.2-.7.2-1.1,0-.8-.2-1.1ZM54.8,36.1c0,.2-.2.3-.3.4,0,0-.3,0-.5,0s-.4,0-.5,0c0,0-.2-.2-.3-.4,0-.2,0-.4,0-.7s0-.5,0-.7c0-.2.2-.3.3-.4,0,0,.3,0,.5,0s.4,0,.5,0c0,0,.2.2.3.4,0,.2,0,.4,0,.7s0,.5,0,.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.4,33.5v4h1v-4h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.5,36.3s0,0-.2.2c0,0,0,0-.2,0h-.3c-.2,0-.4,0-.5,0,0,0-.2-.2-.3-.4,0-.2,0-.4,0-.7s0-.5,0-.7c0-.2.2-.3.3-.4,0,0,.3,0,.5,0h.3s.2,0,.2,0l.2.2v.3h1c0-.2,0-.4-.2-.6,0-.2-.2-.3-.4-.5-.2,0-.3-.2-.5-.3h-.7c-.3,0-.7,0-.9.2-.3,0-.5.4-.7.7s-.2.7-.2,1.1,0,.8.2,1.1.4.5.7.7.6.2,1,.2.5,0,.7,0,.4-.2.5-.3.3-.3.4-.5c0-.2,0-.4,0-.5h-1v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.9,34.2v-.8h-2.8v4h2.8v-.8h-1.8v-.8h1.7v-.8h-1.7v-.8s1.8,0,1.8,0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42.5,
    y: 41.3,
    width: 17.3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42.9,
    y: 77.2,
    width: 17.3,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42.5,
    y: 46.1,
    width: 8.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.2,
    y: 82,
    width: 8.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47,
    y: 56.2,
    width: 8.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47,
    y: 65.5,
    width: 8.6,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 70.3,
    y: 56,
    width: 4.1,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 70.3,
    y: 65.6,
    width: 4.1,
    height: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.5,51.6h-32.9c-.5,0-.9.4-.9.9v18.5c0,.5.4.9.9.9h23.6c.8-.7,2.2-1.8,2.2-1.8v-7.7h6.2v5.1c.6-.2,1.2-.3,1.8-.5v-14.6c0-.5-.4-.9-.9-.9h0ZM58.8,70.1h-14.3v-7.7h14.3v7.7ZM58.8,60.7h-14.3v-7.3h14.3v7.3ZM67.5,70.1h-7v-7.7h7v7.7ZM67.5,60.7h-7v-7.3h7v7.3ZM75.5,60.7h-6.2v-7.3h6.2v7.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 63,
    y: 65.5,
    width: 1.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 63,
    y: 56,
    width: 1.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.6,40.7v1.1h3c.5,0,.9.4.9.9v2.9c0,.5-.4.9-.9.9h-1.1v2.2h-1.8v-2.2h-2v-1.8h3.9v-1.1h-3c-.5,0-.9-.4-.9-.9v-3c0-.5.4-.9.9-.9h1.1v-2.2h1.8v2.2h2v1.9s-3.9,0-3.9,0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicePostPayment);
export default __webpack_public_path__ + "static/media/invoice-post-payment.968bb66e10a9b68770c9998c5606f56b.svg";
export { ForwardRef as ReactComponent };